import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {FilterDrawerService} from '../../../services/filter-drawer.service';

@Component({
  selector: 'app-filter-drawer-toggle',
  templateUrl: './filter-drawer-toggle.component.html',
  styleUrls: ['./filter-drawer-toggle.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
})
export class FilterDrawerToggleComponent {
  filterDrawerService = inject(FilterDrawerService);
}
